import React from 'react';
import classnames from 'classnames';
import { DataViewFilters } from './data-view-filters';
import { DataViewRefresh } from './data-view-refresh';
export var DataViewHeader = function DataViewHeader(props) {
  var title = props.title,
    actions = props.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('data-view-header')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('data-view-title', {
      hidden: !title
    })
  }, /*#__PURE__*/React.createElement("span", null, title)), /*#__PURE__*/React.createElement(DataViewFilters, props), /*#__PURE__*/React.createElement(DataViewRefresh, props), actions && /*#__PURE__*/React.createElement("div", {
    className: classnames('data-view-header-right')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('data-view-table-actions')
  }, actions)));
};